export default {
  INTRODUCE: 'WebsiteSTNHD/GioiThieu',
};
